module.exports = __webpack_public_path__ + "img/Article-image18.286542a8.jpg";